import { RichTextField, Tab, useRecordContext, type TabProps } from 'react-admin';
import { path } from '@/pages/AdverseAction/constants';
import { FCRAWorkerAdverse } from '@/types/turn-api';

const AdverseNoticeTab = (props: Partial<TabProps>) => {
  useRecordContext<FCRAWorkerAdverse.Details>();

  return (
    <Tab label="Adverse Notice" path="adverse" {...props}>
      <RichTextField label="" source={path('adverse.adverse')} />
    </Tab>
  );
};

export default AdverseNoticeTab;
